import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const StyledApplyTopicBlock = styled.div`
    display: flex;
    padding: 7px 16px;
    justify-content: flex-end;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
`;
